<template>
  <div class="button-wrapper">
    <!--v-if="style === styles.BOOTSTRAP"-->
    <button
      type="button"
      :class="classNames"
      :style="'min-width: fit-content;' + customStyle"
      :disabled="disabled"
      @click="$emit('click', $event)"
    >
      <slot name="icon">
        <Icon
          v-if="icon !== ''"
          :icon="icon"
          color="var(--color-main)"
          :style="customIconStyle"
        ></Icon>
      </slot>
      <slot></slot>
    </button>

    <!--<b-button
      v-if="style === styles.VUE_BOOTSTRAP"
      :variant="type"
      style="min-width: fit-content"
      class="custom-btn"
      :disabled="disabled"
      @click="$emit('click', $event)"
    >
      <slot></slot>
    </b-button>-->
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { Icon } from '@iconify/vue2'

let styles = {
  BOOTSTRAP: 'BOOTSTRAP',
  VUE_BOOTSTRAP: 'VUE_BOOTSTRAP',
}
const style = styles.BOOTSTRAP

const props = defineProps({
  type: {
    type: String,
    default: 'primary',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  customStyle: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  transparent: {
    type: Boolean,
    default: false,
  },
  font: {
    type: String,
    default: 'normal normal bold 14px/21px Open Sans',
  },
  customIconStyle: {
    type: Object,
    default() {
      return { fontSize: '28.5px' }
    },
  },
})

const classNames = computed(() => {
  const isPrimaryTransparent = props.type === 'primary' && props.transparent
  const isSecondaryTransparent = props.type === 'secondary' && props.transparent
  const isDangerTransparent = props.type === 'secondary' && props.transparent

  const isBootstrapButton = !(
    isPrimaryTransparent ||
    isSecondaryTransparent ||
    isDangerTransparent
  )

  return {
    'custom-btn btn btn btn-sm native-bootstrap-button': isBootstrapButton,
    'btn-primary': props.type === 'primary' && isBootstrapButton,
    'btn-secondary': props.type === 'secondary' && isBootstrapButton,
    'btn-danger': props.type === 'danger' && isBootstrapButton,
    'btn-primary-transparent': isPrimaryTransparent,
  }
})
</script>
<style lang="scss" scoped>
.button-wrapper {
  cursor: pointer;

  button.custom-btn.btn-secondary:hover {
    color: black;
    background-color: rgb(255 255 255 / 81%);
    border-color: transparent;
  }

  button {
    font: v-bind(font);
    letter-spacing: 0;
    color: #ffffff;

    &[disabled] {
      pointer-events: none;
    }

    &.btn-primary-transparent {
      color: var(--color-main);
      border: 0;
      display: flex;
      justify-content: flex-start;
      column-gap: 7px;
      align-items: center;
      border-radius: 5px;
      padding: 5px 10px;
      font: normal normal bold 12px/20px Open Sans;
      background: transparent;
      transition: background-color 0.15s linear;
      min-height: 40px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      &:focus,
      &.active {
        outline: 0;
        background-color: rgba(0, 0, 0, 0.1);
      }

      img {
        max-width: 23.75px;
        max-height: 23.75px;
      }
    }

    &.btn-secondary {
      color: var(--color-tundora);
    }
  }
}
</style>
